import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { userApi } from "./user.api";
import { useUserStore } from "./user.store";
import type { UpdateMeRequest } from "./user.types";

export const userKeys = {
	all: ["user"] as const,
	me: () => [...userKeys.all, "me"] as const,
	gyul: () => [...userKeys.all, "gyul"] as const,
};

export const useGetMe = () => {
	const setMe = useUserStore((state) => state.setMe);

	const query = useQuery({
		queryKey: userKeys.me(),
		queryFn: () => userApi.getMe(),
	});

	useEffect(() => {
		if (query.data) setMe(query.data);
	}, [query.data, setMe]);

	return query;
};

export const useUpdateMe = () => {
	const queryClient = useQueryClient();
	const setMe = useUserStore((state) => state.setMe);

	return useMutation({
		mutationFn: (request: UpdateMeRequest) => userApi.updateMe(request),
		onSuccess: (data) => {
			setMe(data);
			queryClient.setQueryData(userKeys.me(), data);
			queryClient.invalidateQueries({ queryKey: userKeys.me() });
		},
	});
};

export const useGetGyulDebt = () => {
	const setGyulDebt = useUserStore((state) => state.setGyulDebt);

	const query = useQuery({
		queryKey: userKeys.gyul(),
		queryFn: () => userApi.getGyulDebt(),
	});

	useEffect(() => {
		if (query.data) setGyulDebt(query.data);
	}, [query.data, setGyulDebt]);

	return query;
};
